import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";
import Garcia from "../images/Garcia.png"
import Locklear from "../images/Locklear.png"
import Hoffmann from "../images/Hoffmann.png"
import Drake from "../images/Drake.png"

export default function Article2(props: any) {

  return (
    <div>
      <title>“Who’d We Get?” - An Arizona Diamondbacks Trade Deadline Recap (ft. @dbacksprospectz)
      </title>

      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "34pt" : "20pt",
        }}
      >
        “Who’d We Get?” - An Arizona Diamondbacks Trade Deadline Recap (ft. @dbacksprospectz)
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By @dbacksprospectz on X • August 12th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />
      <>
        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          2025 was expected to be a year of triumph for the Diamondbacks. Who would think that a potent offense, rotation with two "aces," and a bullpen filled with power arms like Justin Martinez would falter? They even had depth in Triple-A Reno to cover injuries.
          <br /><br />
          As we now know, the worst-case scenario happened. Fourteen active injuries on their 40-man roster and nine in Reno led to the collapse of the 2025 Diamondbacks. The result was a painful sell-off. Eugenio Suárez, Josh Naylor, Randal Grichuk, Shelby Miller, Jordan Montgomery, and Merrill Kelly were all shipped off to contenders. The return: nine prospects, eight of them pitchers.
          <div style={{ margin: "auto", width: "500px", marginBottom: "20px" }}>
            <img
              src={"https://epkj6wiuwza.exactdn.com/wp-content/uploads/2025/08/USATSI_26780062.jpg"}
              alt="Dbacks trade deadline graphic"
              style={{ maxWidth: "75vw", maxHeight: "400px", border: "#293241 solid 2px" }}
            />
          </div>
          With the trade deadline in the rearview mirror, let's examine the Diamondbacks' returns.
          <br /><br />
        </Typography>

        {/* Naylor Trade */}
        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #0d6efd",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Mariners Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>1B Josh Naylor</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Diamondbacks Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              LHP <a href="/player/805299" style={{ color: "#0d6efd", textDecoration: "none" }}>Brandyn Garcia</a> (SEA #13),<br />
              RHP Ashton Izzi (SEA #16)
            </div>
          </div>
        </div>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          LHP Brandyn Garcia
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Brandyn Garcia has seen almost immediate MLB action since his trade to Arizona. The results have been shaky, to put it bluntly. He currently finds himself working out command cues in Triple-A Reno.
          <br /><br />
          As you can see from the Prospect Savant graphic, Brandyn Garcia has all the markings of the traditional hard-throwing lefty arm. Brandyn’s main attack point is a sidewinding mid-to-upper 90s sinker. It holds a flat, but arm-side approach to the plate (3 VB, 16 HB). This is not his whiff pitch, and that’s telling with the high contact rates against him. His 53.9% ground ball rate throughout his time in Tacoma and Reno is telling in the effectiveness of the offering, though. <br /><br />
        </Typography>

        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Garcia}
            alt="Brandyn Garcia pitch metrics"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          He pairs the high-velocity sinker with a mid-80s sweeper and a high-80s slider. The slider has the cutter variety's movement profile, producing fantastic results against it. Batters against Garcia’s slider have only managed a .199 xBA and a .246 xwOBA, whiffing 28% of the time against the offering. While used less, the sweeper flashes plus in terms of underlying results. The .087 xBA, .147 xwOBA, and 50% whiff rate against the offering show how lethal Brandyn can be if he keeps himself in the zone. While Brandyn gets in the zone with all his pitches, he struggles to leave them in good locations. The Diamondbacks have prioritized working on this with him in Reno.  <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Ashton Izzi
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Izzi's 5.04 ERA and 4.54 FIP hide promising underlying metrics. He performed significantly better away from hitter-friendly Everett (90-point OPS difference).
          <br /><br />
          The righty features a mid-90s fastball/sinker combo with strong movement, though in-zone results need improvement. His marquee pitch is a mid-80s slider with plus miss and chase rates. A high-80s changeup shows serious depth against lefties. With seven feet of extension and 5.8' release height, he projects as a #3 starter. Multiple teams inquired about Izzi post-trade.
          <br /><br />
          Getting a near-MLB lefty and upside starter for a rental 1B represents excellent value.
          <br /><br />
        </Typography>

        {/* Grichuk Trade */}
        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #dc3545",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Royals Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>OF/DH Randal Grichuk</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Diamondbacks Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              RHP <a href="/player/694851" style={{ color: "#0d6efd", textDecoration: "none" }}>Andrew Hoffmann</a> (unranked)
            </div>
          </div>
        </div>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Andrew Hoffmann
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Hoffmann continues Arizona's trend of acquiring high-velocity relievers with interesting breakers. Between Omaha and Reno, he's posted a 2.14 ERA and 2.34 FIP.
          <br /><br />
        </Typography>

        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Hoffmann}
            alt="Andrew Hoffmann performance metrics"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          His standout pitch is a high-80s changeup with negative vertical break (.171 xBA, .183 xwOBA, 38% whiff rate). A mid-to-upper 90s fastball pairs well (31.3% whiff rate, .248 xwOBA). Location issues plague Hoffmann - his changeup often catches too much plate, forcing over-reliance on the fastball. If refined, he could become a back-end bullpen arm.
          <br /><br />
        </Typography>

        {/* Suarez Trade */}
        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #198754",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Mariners Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>3B Eugenio Suárez</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Diamondbacks Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              1B <a href="/player/682988" style={{ color: "#0d6efd", textDecoration: "none" }}>Tyler Locklear</a> (SEA #14),<br />
              RHP Hunter Cranton (SEA #16),<br />
              RHP <a href="/player/686228" style={{ color: "#0d6efd", textDecoration: "none" }}>Juan Burgos</a> (SEA #17)
            </div>
          </div>
        </div>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          1B Tyler Locklear
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Locklear's batted ball results have been exceptional with improved strikeout rates. Despite being a first baseman, he has decent speed and will steal bases. Defensively, he's solid at first.
          <br /><br />
        </Typography>

        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <img
            src={Locklear}
            alt="Tyler Locklear batted ball metrics"
            style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
          />
        </div>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          His season splits reveal a dramatic transformation:
          <br /><br />
          <strong>Pre-June 6:</strong> .282/.366/.414, .344 wOBA, 29% whiff<br />
          <strong>Post-June 6:</strong> .366/.448/.720, .484 wOBA<br />
          <br />
          The improvement came from quieting his swing (lower hand position, reduced bat wiggle). He'll get extended MLB time at first base, potentially solving Arizona's 2026 1B dilemma.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Juan Burgos
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Burgos mirrors Garcia's profile from the right side. His batted ball quality is excellent, but he struggles with line drives and consistent whiffs due to control issues.
          <br /><br />
          His arsenal includes a cutter-ish slider (.188 xBA, .222 xwOBA), a mid-90s sinker, and a plus sweeper/curve. To stick as a reliever, he needs better pitch separation and zone command.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP Hunter Cranton
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Cranton features an upper-90s fastball with exceptional ride and run, paired with an upper-80s "bullet" slider that baffles hitters. His control is solid, but injuries have limited him to just 20 innings. Currently on Amarillo's IL with groin discomfort, his potential is tantalizing but health-dependent.
          <br /><br />
        </Typography>

        {/* Kelly Trade */}
        <div style={{
          margin: "20px 0",
          padding: "15px",
          backgroundColor: "#f8f9fa",
          borderLeft: "4px solid #ffc107",
          borderRadius: "4px"
        }}>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Rangers Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>RHP Merrill Kelly</div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Diamondbacks Receive:</div>
            <div style={{ flex: 2, fontSize: "14pt" }}>
              LHP <a href="/player/684442" style={{ color: "#0d6efd", textDecoration: "none" }}>Kohl Drake</a> (TEX #5),<br />
              LHP Mitch Bratt (TEX #9),<br />
              RHP David Hagaman (TEX #13)
            </div>
          </div>
        </div>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          LHP Kohl Drake
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          The headliner of the Kelly deal, Drake has produced excellent batted ball results despite PCL inflation. He's not a hard thrower (92-94 MPH fastball) but commands it exceptionally (58% zone rate, 18% swinging strike rate).
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <img
              src={Drake}
              alt="Kohl performance metrics"
              style={{ maxWidth: "90%", border: "#293241 solid 2px" }}
            />
          </div>
          His mid-80s slider (60% zone rate, 12% whiff rate) is effective when located well. A mid-80s changeup and low-80s curve show promise but are underutilized. Projects as a #4/#5 starter who could debut this season.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          LHP Mitch Bratt
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Bratt thrives on elite command (4.3% BB rate) rather than pure stuff. His low-90s fastball plays up due to exceptional ride and high-zone location.
          <br /><br />
          His low-80s slider works against both sides of the plate, and a changeup gives lefties fits. With a 29% strikeout rate and strong batted ball data, he profiles similarly to Kris Bubic. Added velocity would raise his ceiling.
          <br /><br />
        </Typography>

        <Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
          RHP David Hagaman
        </Typography>
        <br />

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          Recently returned from Tommy John, Hagaman has the highest ceiling of Arizona's deadline starters. In 26 innings: 2.77 ERA, 2.20 FIP, 30.4% K rate.
          <br /><br />
          Features a mid-90s fastball with excellent ride (54% zone rate) and a plus mid-80s slider (22% swinging strike rate). His changeup decimates lefties. Needs to improve fastball location against righties and add a true put-away pitch. Ceiling comparable to Kevin Gausman.
          <br /><br />
        </Typography>

        <Typography
          variant="body2"
          style={{
            color: "rgba(0, 0, 0, 1)",
            fontSize: "13pt"
          }}
        >
          The Shelby Miller/Jordan Montgomery return remains pending (PTBNL or cash). Overall, Arizona accomplished its goals: acquiring young starters, power relievers, and a 2026 1B solution.
          <br /><br />
          Eight of nine acquired prospects rank in Arizona's Top 30 per MLB Pipeline - the most added by any team. Combined with their draft focus on power arms, Hazen has rebuilt a pitching pipeline that can either develop homegrown talent or trade for MLB pieces.
          <br /><br />
          While the Suárez return raised eyebrows, it was a win-win deadline in a painful season. Hazen now has the assets to accelerate Arizona's rebound.
          <br /><br />
          Whether Hazen can prove the doubters wrong about their return remains to be seen, but it has brought tremendous value to the organization. Eight of the nine players Mike Hazen acquired at the 2025 trade deadline are on MLB Pipeline’s Top 30 Diamondbacks Prospects, the most that any team added to their top 30 during this deadline. In addition, hope has begun to sprout for Diamondbacks fans in the system, as it finally has the pitching it desperately needs.
          <br /><br />
          With Hazen and Co.’s recent draft of high-velocity starters and strong relievers, it’s clear a change is occurring in the organization. Their previous pitching philosophy hasn’t worked out, and the necessary moves to fix the system’s pitching woes have been made. By acquiring even more talent and baking it into the system, Mike Hazen has the tools to trade his prospects away for MLB-caliber guys. It was a win-win deadline in an otherwise lackluster, painful season for the Snakes.
          <br /><br />
          For those who enjoyed the articles, I post constantly about Diamondbacks prospects on my Twitter/X account, <a href="https://x.com/dbacksprospectz">@dbacksprospectz</a> for constant Diamondbacks prospect coverage. Thank you for reading!
        </Typography>
      </>
    </div>
  );
}
